export class StoreItemRequest {
    location: string;
    contactType: number;
    contactEmail: string;
    contactPhone: string;
    contactTime: number;
    contactTimePeriod: number;
    requestDescription: string;
    targetDeviceId: number;
    customerCC: string;
    formSubmission: string;
    customFields: (CustomFieldRequest)[] | null;
}
export class CustomFieldRequest {
    fieldId: number;
    fieldValue: string;
}
